export default __webpack_public_path__ + "static/media/propic2.79bfd233.png";